var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67389 1.01643C9.87917 0.913793 10.1208 0.913793 10.3261 1.01643L18.6594 5.1831C18.9064 5.30662 19.0625 5.5591 19.0625 5.83529C19.0625 6.11147 18.9064 6.36396 18.6594 6.48747L10.3261 10.6541C10.1208 10.7568 9.87917 10.7568 9.67389 10.6541L1.34055 6.48747C1.09352 6.36396 0.93748 6.11147 0.93748 5.83529C0.93748 5.5591 1.09352 5.30662 1.34055 5.1831L9.67389 1.01643ZM3.29711 5.83529L9.99998 9.18672L16.7028 5.83529L9.99998 2.48385L3.29711 5.83529ZM1.0144 13.843C1.19449 13.4828 1.63248 13.3368 1.99268 13.5169L9.99992 17.5205L18.0072 13.5169C18.3673 13.3368 18.8053 13.4828 18.9854 13.843C19.1655 14.2032 19.0195 14.6412 18.6593 14.8213L10.326 18.988C10.1207 19.0906 9.8791 19.0906 9.67382 18.988L1.34049 14.8213C0.980296 14.6412 0.834299 14.2032 1.0144 13.843ZM1.99268 9.34895C1.63248 9.16885 1.19449 9.31485 1.0144 9.67504C0.834299 10.0352 0.980296 10.4732 1.34049 10.6533L9.67382 14.82C9.8791 14.9226 10.1207 14.9226 10.326 14.82L18.6593 10.6533C19.0195 10.4732 19.1655 10.0352 18.9854 9.67504C18.8053 9.31485 18.3673 9.16885 18.0072 9.34895L9.99992 13.3526L1.99268 9.34895Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.69408b65a08d059b5f035c57175d135d.svg";
export { ForwardRef as ReactComponent };